/* src/app/components/ai-library/ai-library/e-library-details/ai-library-details.component.scss */
.top-box-shadow {
  box-shadow: none;
}
header {
  background: transparent !important;
}
.input {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.02) 0px 0px 0px 1px !important;
}
.tabs {
  padding: 0.5rem 0rem;
}
select.form-select {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.2) 0px 0px 0px 1px !important;
  color: #666;
  max-width: 170px;
}
.elibrary-filter {
  background: #fff;
  padding: 10px;
}
.notification-content-wrapper {
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
}
.policy-upload .modal-dialog {
  max-width: calc(100vw - 50px) !important;
}
.policy-upload .modal-dialog .modal-content {
  width: 100% !important;
}
.policy-upload .modal-dialog .modal-body {
  padding: 0px !important;
}
.policy-upload .modal-dialog ::ng-deep .card {
  box-shadow: none !important;
}
.policy-upload .modal-dialog ::ng-deep .card .card-body {
  min-height: calc(100vh - 300px) !important;
}
.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
  background: #fafafa !important;
}
.modal-dialog .modal-body .field.pos-relative {
  background: #fff !important;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal-dialog .btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.modal-dialog .btn-cancel {
  background-color: #eee;
  color: #111;
}
.modal-dialog .btn {
  padding: 0.3rem 0.8rem !important;
}
.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}
.modal.show {
  display: block;
}
.modal-header {
  background: var(--primaryColor);
  color: #fff;
}
/*# sourceMappingURL=ai-library-details.component.css.map */
